// DS: C115
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useEffect } from 'react';
import { useDismissableNotification } from '../Notifications/Notification/useDismissableNotification';
import LiveNotificationCard from './_partials/LiveNotificationCard';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import liveNotificationsStyle from './LiveNotifications.scss';
const LiveNotification = ({ id, queueName, notificationHtml, linkTo, biData })=>{
    const logBiEvent = useBiLogger();
    const { onClose, onPause, onUnpause } = useDismissableNotification({
        id,
        queueName,
        duration: 10000
    });
    useEffect(()=>{
        logBiEvent(BiData(_object_spread({
            evid: 656
        }, biData)));
    }, [
        logBiEvent,
        biData
    ]);
    return /*#__PURE__*/ React.createElement(LiveNotificationCard, {
        onClose: onClose,
        onMouseEnter: onPause,
        onMouseLeave: onUnpause,
        biData: biData
    }, linkTo ? /*#__PURE__*/ React.createElement(BiLink, {
        href: linkTo,
        className: liveNotificationsStyle['notification-link'],
        dangerouslySetInnerHTML: {
            __html: notificationHtml
        },
        biData: BiData(_object_spread({
            sectionid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            evid: 100
        }, biData))
    }) : /*#__PURE__*/ React.createElement(BiSpan, {
        dangerouslySetInnerHTML: {
            __html: notificationHtml
        },
        biData: BiData(_object_spread({
            sectionid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            evid: 100
        }, biData))
    }));
};
LiveNotification.displayName = 'LiveNotification';
export default LiveNotification;
